import { httpService } from '~/Services/Service';

// Backend usa SnakeCaseNamingStrategy global (Startup.cs) — payload precisa ir em snake_case
const paraSnakeCase = (valor) => {
  if (valor === null || valor === undefined) return valor;
  if (Array.isArray(valor)) return valor.map(paraSnakeCase);
  if (typeof valor !== 'object') return valor;
  return Object.keys(valor).reduce((acc, chave) => {
    const chaveSnake = chave.replace(/([A-Z])/g, '_$1').toLowerCase();
    acc[chaveSnake] = paraSnakeCase(valor[chave]);
    return acc;
  }, {});
};

export const listarGesListaAtivos = () =>
  httpService.get('/lista-ativos/ges');

export const listarGruposGeListaAtivos = () =>
  httpService.get('/lista-ativos/grupos-ge');

export const listarMoedasListaAtivos = () =>
  httpService.get('/lista-ativos/moedas');

export const gerarListaAtivos = (payload) =>
  httpService.post('/lista-ativos/gerar', paraSnakeCase(payload));

// httpService.post empurra o 3º arg como headers HTTP — para responseType ir
// na raiz da config do axios, chamamos fetch direto (Helpers.js:salvarEmExcel)
export const exportarListaAtivos = (payload) =>
  httpService.fetch({
    url: '/exportador/excel/lista-ativos',
    method: 'post',
    data: paraSnakeCase(payload),
    responseType: 'blob',
  });
